import moment from "moment";
export const INIT_FILTER_STATE = {
  startDate: moment().subtract(30, "days").toDate(),
  endDate: moment().subtract(1, "days").toDate(),
  // startDate: moment(new Date("2024-12-16T00:00:00.000Z")).toDate(),
  // endDate: moment(new Date("2025-01-20T00:00:00.000Z")).toDate(),
  VIN_NUM: [],
  CITY: [],
  LOB: [],
  PPL: [],
  PL: [],
  SOC: 0,
  pageSelected: 1,
  DEPO: [],
  AIR_VENTILATION: "",
};

let currentDate = moment();
let currentDate1 = moment();

// Subtract 2 days from the current date
let twoDaysAgo = currentDate.subtract(1, "days");
let nineDaysAgo = currentDate1.subtract(8, "days");

// Convert the moment object to a JavaScript Date object
let twoDaysAgoDate = twoDaysAgo.toDate();
let nineDaysAgoDate = nineDaysAgo.toDate();

// gloabalfilter for pdf section
export const INIT_FILTER_STATE_PDF = {
  startDate: nineDaysAgoDate,
  endDate: twoDaysAgoDate,
  VIN_NUM: [],
  CITY: [],
  LOB: [],
  PPL: [],
  PL: [],
  SOC: 0,
  pageSelected: 1,
  DEPO: [],
  AIR_VENTILATION: "",
};

// export const API_URL_MAIN = "https://fleetascents.dev.ev.cv.tatamotors/api/";
export const API_URL_MAIN = process.env.REACT_APP_BASE_URL;
// export const API_URL_MAIN = "https://fleetascents.dev.ev.tatamotors.com/api/";
// export const API_URL_MAIN = "http://10.164.59.172:5053/api/";

export const INIT_STATE_SELECTS = {
  // startDate: moment().subtract(30, "days").toDate(),
  // endDate: moment().subtract(1, "days").toDate(),
  startDate: moment(new Date("2024-12-16T00:00:00.000Z")).toDate(),
  endDate: moment(new Date("2025-01-20T00:00:00.000Z")).toDate(),
  VIN_NUM: [],
  CITY: [],
  LOB: [],
  PPL: [],
  PL: [],
  SOC: 0,
  pageSelected: 1,
  DEPO: [],
  AIR_VENTILATION: "",
};

export const INDEX = {
  CITY_INDEX: "CITY",
  LOB_INDEX: "LOB",
  PPL_INDEX: "PPL",
  PL_INDEX: "PL",
  SOC_INDEX: "SOC",
  DEPO_INDEX: "DEPO",
  AIR_VENTILATION_INDEX: "AIR_VENTILATION",
};
